import { FormGroupState } from "ngrx-forms";

export interface IGreenIdState {
  model: GreenIdModel;
  isLoading: boolean;
  submittedDate: null | Date;
  scriptLoaded: boolean;
  member: FormGroupState<GreenIdMemberDataResponseModel> | null;
  consentForm: FormGroupState<GreenIdConsentModel>;
  consentSaving: boolean;
  consentError: boolean;
  consentCompletedDate: null | Date;
}

export class GreenIdConsentModel {
  agree: boolean = false;
}

export class GreenIdModel {
  verificationId: string = '';
  verificationToken: string = '';
  verified: boolean = false;
  overallStatus: string = '';
  member: GreenIdMemberDataResponseModel | null = null;
  errorList: string[] = [];
  expiryDate: string = '';
  hasConsented: boolean = false;
}

export class GreenIdMemberDataResponseModel {
  email: string = '';
  firstName: string = '';
  middleName: string = '';
  lastName: string = '';
  country: string = '';
  state: string = '';
  lineOne: string = '';
  suburb: string = '';
  postCode: string = '';
  dob: string = '';
}
